import { isMobileAtom, useRecoil } from '@orcar/common-d2c';
import CustomerServiceLayout from './components/CustomerServiceLayout';
import MobileCustomerServiceLayout from './components/mobile/MobileCustomerServiceLayout';

const CustomerServicePage = () => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);

  return (
    <>
      {isMobile ? <MobileCustomerServiceLayout /> : <CustomerServiceLayout />}
    </>
  );
};

export default CustomerServicePage;
